import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7428eb4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-input-group-wrapper"
}
const _hoisted_2 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_3 = { class: "ant-input-group-addon ss-grupo-icone-recurso-destaque" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cadastrar", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "ss-informacao-adicional-select ss-tag",
  style: 'background-color: #a0aec1;'
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cadastrar", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "ss-informacao-adicional-select ss-tag",
  style: 'background-color: #a0aec1;'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_campo_carregando = _resolveComponent("campo-carregando")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_forma_pagamento_modal = _resolveComponent("forma-pagamento-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.apresentacaoPersonalizada)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_icone, {
                class: "ss-icone ss-icone-recurso-destaque",
                nome: "dinheiro"
              })
            ]),
            _createVNode(_component_a_form_item, {
              label: _ctx.props.label,
              class: "ss-margin-campos",
              rules: [{ required: _ctx.props.required }]
            }, {
              default: _withCtx(() => [
                (_ctx.aguardarConclusaoCarregamento(_ctx.computedCodigoSelecionado, _ctx.computedCodigosSelecionados))
                  ? (_openBlock(), _createBlock(_component_campo_carregando, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_a_select, {
                      key: 1,
                      mode: _ctx.props.varios ? 'multiple' : null,
                      value: _ctx.props.varios ? _ctx.computedCodigosSelecionados : _ctx.computedCodigoSelecionado,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.props.varios ? _ctx.computedCodigosSelecionados = $event : _ctx.computedCodigoSelecionado = $event)),
                      onChange: _ctx.change,
                      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarRegistro(''))),
                      onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pesquisarRegistro($event))),
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false)),
                      "show-search": "",
                      optionFilterProp: "label",
                      class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
                      allowClear: _ctx.props.limparSelecao,
                      placeholder: _ctx.props.placeholder,
                      filterOption: false,
                      "not-found-content": _ctx.selecionarBase.buscandoDados ? undefined : null,
                      disabled: _ctx.props.disabled,
                      title: _ctx.props.title,
                      "data-coluna": _ctx.props.dataAttributeColuna
                    }, _createSlots({
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecionarBase.listaItensConsultaRapida, (registro) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: registro.codigo,
                            value: registro.codigo,
                            class: _normalizeClass(registro.codigo === 0? 'ss-opcao-btn':'')
                          }, {
                            default: _withCtx(() => [
                              (registro.codigo === 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cadastrar && _ctx.cadastrar(...args)), ["stop"])),
                                    class: "ant-btn ant-btn-primary ant-btn-sm ss-btn-opcao ss-tamanho-completo",
                                    type: "button"
                                  }, _hoisted_5))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(registro.textoIdentificacao) + " ", 1),
                                    (registro.informacaoAdicional !== undefined && registro.informacaoAdicional !== '')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(registro.informacaoAdicional), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                            ]),
                            _: 2
                          }, 1032, ["value", "class"]))
                        }), 128))
                      ]),
                      _: 2
                    }, [
                      (_ctx.selecionarBase.buscandoDados)
                        ? {
                            name: "notFoundContent",
                            fn: _withCtx(() => [
                              _createTextVNode(" Buscando Formas de Pagamentos "),
                              _createVNode(_component_a_spin)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["mode", "value", "onChange", "class", "allowClear", "placeholder", "not-found-content", "disabled", "title", "data-coluna"]))
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.aguardarConclusaoCarregamento(_ctx.computedCodigoSelecionado, _ctx.computedCodigosSelecionados))
            ? (_openBlock(), _createBlock(_component_campo_carregando, { key: 0 }))
            : (_openBlock(), _createBlock(_component_a_select, {
                key: 1,
                mode: _ctx.props.varios ? 'multiple' : null,
                value: _ctx.props.varios ? _ctx.computedCodigosSelecionados : _ctx.computedCodigoSelecionado,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.props.varios ? _ctx.computedCodigosSelecionados = $event : _ctx.computedCodigoSelecionado = $event)),
                onChange: _ctx.change,
                onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pesquisarRegistro(''))),
                onSearch: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pesquisarRegistro($event))),
                onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false)),
                "show-search": "",
                optionFilterProp: "label",
                class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
                allowClear: _ctx.props.limparSelecao,
                placeholder: _ctx.props.placeholder,
                filterOption: false,
                "not-found-content": _ctx.selecionarBase.buscandoDados ? undefined : null,
                disabled: _ctx.props.disabled,
                title: _ctx.props.title,
                "data-coluna": _ctx.props.dataAttributeColuna
              }, _createSlots({
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecionarBase.listaItensConsultaRapida, (registro) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: registro.codigo,
                      value: registro.codigo,
                      class: _normalizeClass(registro.codigo === 0? 'ss-opcao-btn':'')
                    }, {
                      default: _withCtx(() => [
                        (registro.codigo === 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cadastrar && _ctx.cadastrar(...args)), ["stop"])),
                              class: "ant-btn ant-btn-primary ant-btn-sm ss-btn-opcao ss-tamanho-completo",
                              type: "button"
                            }, _hoisted_8))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(registro.textoIdentificacao) + " ", 1),
                              (registro.informacaoAdicional !== undefined && registro.informacaoAdicional !== '')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(registro.informacaoAdicional), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]),
                      _: 2
                    }, 1032, ["value", "class"]))
                  }), 128))
                ]),
                _: 2
              }, [
                (_ctx.selecionarBase.buscandoDados)
                  ? {
                      name: "notFoundContent",
                      fn: _withCtx(() => [
                        _createTextVNode(" Buscando Formas de Pagamentos "),
                        _createVNode(_component_a_spin)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["mode", "value", "onChange", "class", "allowClear", "placeholder", "not-found-content", "disabled", "title", "data-coluna"]))
        ], 64)),
    (_ctx.props.apresentarCadastro)
      ? (_openBlock(), _createBlock(_component_forma_pagamento_modal, {
          key: 2,
          visivel: _ctx.selecionarBase.apresentarCadastro,
          "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selecionarBase.apresentarCadastro) = $event)),
          operacao: _ctx.selecionarBase.operacaoCadastro
        }, null, 8, ["visivel", "operacao"]))
      : _createCommentVNode("", true)
  ]))
}